import { createApp } from 'vue'
import App from './App.vue'
import '@/styles/ainotebook.global.scss'

createApp(App).mount('#app')
